module.exports = __webpack_public_path__ + "static/media/3d-connections.1340b9e9.png";